import React from 'react';
import EvidencePanel from './EvidencePanel';

const QuestionCard = ({
  question,
  response,
  isLocked,
  highlighted,
  onAnswerChange,
  onEvidenceChange,
  onFilesSelected,
  onRemoveBackendFile,
  onRetryPendingFile,
  onRemovePendingFile,
  darkMode,
  theme,
}) => {
  const highlightClass = darkMode
    ? 'ring-4 ring-red-500 bg-red-900/20 border border-red-700'
    : 'ring-4 ring-red-400 bg-red-50 text-gray-900 border border-red-200';

  const answerClass =
    response.answer === 'Yes'
      ? darkMode
        ? 'bg-green-900/20 border-green-600 text-green-300'
        : 'bg-green-50 border-green-500 text-green-900'
      : response.answer === 'No'
      ? darkMode
        ? 'bg-red-900/20 border-red-600 text-red-300'
        : 'bg-red-50 border-red-500 text-red-900'
      : isLocked
      ? theme.disabledInput
      : theme.input;

  return (
    <div
      id={`question-${question.id}`}
      className={`mb-6 p-4 rounded-lg shadow transition ${
        highlighted ? highlightClass : isLocked ? theme.lockedCard : theme.questionCard
      }`}
    >
      <label className={`block font-semibold mb-3 ${theme.text}`}>
        Q{question.order}: {question.request}
      </label>

      <select
        value={response.answer || ''}
        onChange={(e) => onAnswerChange(question.id, e.target.value)}
        disabled={isLocked}
        className={`w-full border-2 rounded-lg p-3 mb-3 font-medium focus:outline-none ${answerClass}`}
      >
        <option value="">-- Select Answer --</option>
        <option value="Yes">✅ Yes</option>
        <option value="No">❌ No</option>
      </select>

      {response.answer === 'Yes' && (
        <EvidencePanel
          response={response}
          questionId={question.id}
          isLocked={isLocked}
          onEvidenceChange={onEvidenceChange}
          onFilesSelected={onFilesSelected}
          onRemoveBackendFile={onRemoveBackendFile}
          onRetryPendingFile={onRetryPendingFile}
          onRemovePendingFile={onRemovePendingFile}
          darkMode={darkMode}
          theme={theme}
        />
      )}
    </div>
  );
};

export default QuestionCard;